import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import banner from "../../../components/banner";
import news from "../../../components/news";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import maskPDF from "../../../components/maskPDF";
import customerTalk from "../../../components/customerTalk";
import './caseHotel.less'
export default {
    name: "caseHotel",
    data() {
        return {
            black:{
                title: '小精灵数字酒店方案以移动支付入口，通过电子会员卡、订房小程序、客房点餐、活动会议、预授权的能力，构建酒店私域流量体系，提升酒店运营效率，最终达到提升营收的效果',
                info: '据统计，线上OTA占据着线下酒店客流的70%，而平台扣极高商家却无能为力，线下门店因为流量的粗放运营，也是白白流失掉自己的会员，因此构建酒店私域流量迫在眉睫'
            },
            info: [
                {
                    title1: '电子会员卡',
                    title2: '沉淀会员如此简单',
                    pic: 'img/caseHotel/info1.png',
                    info: '微信原生卡包，3秒开卡，自动标签，服务通知，随时触达。',
                    block: ''
                },
                {
                    title1: '酒店预授权',
                    title2: '让结算更简单',
                    pic: 'img/caseHotel/info2.png',
                    info: '顾客付款预定房间，自动冻结用户可用资金，结算时从冻结资金划扣给商户，剩余资金解冻返还给顾客的产品能力。',
                    block: 'swap'
                },
                {
                    title1: '活动会议',
                    title2: '让每个参会者都成为会员',
                    pic: 'img/caseHotel/info3.png',
                    info: '酒店很多活动和会议，但是酒店很难掌握这部分参会者数据，运用活动工具，让每个参会者都能成为会员，开卡即送券拉动门店营业额增长。',
                    block: ''
                },
                {
                    title1: '客房扫码点餐',
                    title2: '入住体验更棒',
                    pic: 'img/caseHotel/info4.png',
                    info: '间内自主扫码点餐，餐厅配餐，体验更棒。',
                    block: 'swap'
                },
                {
                    title1: '自有点订房小程序',
                    title2: '拒绝平台高额扣点',
                    pic: 'img/caseHotel/info5.png',
                    info: '在线订房，在线储值余额自动抵扣，在线升级，享受订房权益，培养忠实客户。',
                    block: ''
                }
            ],
            rollList: [
                {
                    src: "/img/caseHotel/lun1.png",
                    size: 3,
                },
                {
                    src: "/img/caseHotel/lun2.png",
                    size: 4,
                },
                {
                    src: "/img/caseHotel/lun3.png",
                    size: 2,
                },
                {
                    src: "/img/caseHotel/lun4.png",
                    size: 4,
                }
            ],
            hotel: {
                title: '酒店优质客户案例',
                more: '',
                num: 3,
                info: [
                    {
                        pic: "/img/caseHotel/hotel1.png",
                        title: "南阳【盛世开元商务酒店】用员工分销轻松撬动千万储值",
                        txt: "5个等级的储值，关联126个员工的员工分销二维码，储值晋升对应等级会员，仅用2个月储值超300万",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseHotel/hotel2.png",
                        title: "济南【上善若水休闲酒店】借用卡券商城，把发券核销率做到43%",
                        txt: "卡券商城结合服务通知，售卖客房、洗浴、汗蒸等券，卖券1万余张，仅开卡有礼的券核销率占比达到43%",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseHotel/hotel3.png",
                        title: "广东【月亮酒店】自建订房小程序，快速实现私域流量会员变现",
                        txt: "区域连锁快捷酒店，OTA的依赖极高，开卡有礼，快速吸粉2万会员后，自建订房小程序，将自有流量快速变现",
                        pdf: "",
                    },
                ]
            },
            customerTalk1: {
                bg: '#e1e5f5',
                pic: 'img/caseHotel/person1.png',
                info: '“酒店是服务性行业，需要每个店员都有主动服务的意识，所以员工的激励和考核很重要，小精灵的员工分销能力让每个员工都更加有了主动的、积极的服务与推广意识，门店管理有了数据依据，让管理和激励变得更简单。”',
                person: '— 张先生，盛世开源商务酒店，酒店大堂经理'
            }
        }
    },
    components: {
        skeleton,
        banner,
        news,
        customerTalk,
        pay,
        QRCode,
        maskPDF,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
